<template>
    <div class="checkout relative">
    <VivaLoader />
    <HeaderDashboard />
    <ModalValidation :show="showModalValidation"  @close="onCloseValidation" :validatedField="validation"/>

        <main class="checkout-component bg-gray-50 pt-16 md:pt-36 pb-10">
            <div class="mx-auto flex flex-col md:flex-row max-w-7xl container">
                <DashboardSidebarMenu isPage="pagos" class="hidden md:block"/>
                <div class="main-content w-full md:w-4/5 flex flex-col">
                    <section class="mb-5">
                        <div class="max-w-6xl mx-auto px-4">
                        <DashboardUserCardInformation />
                        </div>
                    </section>
                    <section class="mb-6">
                        <div class="max-w-6xl mx-auto px-4" v-if="subscription">
                           <Notification
                            type="warning"
                            :title="
                            notificationTranslate[language].expireMembership(  formatExpirationDate( subscription.subscription.cancelationDate  ) ) "
                            v-if="subscription.subscription.cancelationDate"
                            />
                        </div>
                        <div class="max-w-6xl mx-auto px-4">
                           <Notification
                                type="error"
                                title="Error"
                                :content="error"
                                v-if="error"
                            /> 
                            <Notification
                                type="success"
                                :title="notificationTranslate[language].successBillingChange.title"
                                :content="notificationTranslate[language].successBillingChange.subtitle"
                                v-if="isSuccess"
                            /> 
                        </div>
                    </section>
                    <section class="mb-0">
                        <div class="max-w-6xl mx-auto px-4">
                            <div class="flex flex-col lg:flex-row justify-between w-full lg:space-x-6 items-start">
                                <div class="box w-full flex flex-col justify-between p-6 mb-5 lg:mb-0">
                                    <h3 class="section-header text-2xl text-green-500 font-semibold md:font-bold mb-5">
                                        {{checkoutTranslate[language].user.changeCCTitle}}
                                    </h3>
                                    <div class="flex justify-between pb-3" v-if="subscription">
                                        <form id="form">
                                            <h4 class="mb-3">{{checkoutTranslate[language].user.creditCard}}</h4>
                                            <div class="flex mb-3">
                                                <span class="mr-1"><img class="w-16 h-auto" src="@/assets/img/cc/mastercard.svg" alt="Mastercard"></span>
                                                <span class="mr-2"><img class="w-16 h-auto" src="@/assets/img/cc/visa.svg" alt="Visa"></span>
                                                <span class="mr-1"><img class="w-16 h-auto" src="@/assets/img/cc/amex.svg" alt="Amex"></span>
                                            </div>
                                            <div class="flex flex-col md:flex-col justify-between items-center pb-5">
                                            <!-- Recurly Elements will be attached here -->
                                             <div class="my-4 w-full flex align-middle">
                                                <FontAwesomeIcon :icon="faExclamationCircle" class="text-green-120 mr-1 "></FontAwesomeIcon> 
                                                <span class="text-xs">{{checkoutTranslate[language].details.cardDetails}}</span>
                                            </div>
                                            <div class="w-full flex flex-col sm:flex-row font-semibold text-left focus:ring-green-400 focus:border-green-400 text-18 border-gray-300 pt-3 pb-1 px-4 rounded-xl shadow-sm border text-green-500 outline-none mb-5">
                                                <div class="w-full md:w-1/2">
                                                    <div class="elative w-full">
                                                        <label class="px-0 text-sm font-medium flex items-center">
                                                            <span>
                                                                {{checkoutTranslate[language].user.cardNumber}}
                                                            </span>
                                                        </label>
                                                        <div id="recurly-number"></div>
                                                        <span v-if="validation.number" class="text-red-100"> {{validation.number }} </span>
                                                    </div>
                                                </div>
                                                <div class="w-full sm:w-1/2 flex">
                                                    <div class="w-1/2">
                                                        <div class="relative w-full">
                                                            <label class="px-0 text-sm font-medium flex items-center">
                                                                <span> {{checkoutTranslate[language].user.cardExpiration}}</span>
                                                            </label>
                                                            <div class="flex justify-start text-gray-300">
                                                                <div id="recurly-month"></div><span class="text-gray-300">/</span><div id="recurly-year"></div>
                                                            </div>
                                                            <span v-if="validation.month" class="text-red-100"> {{validation.month }} </span>
                                                        </div>
                                                    </div>
                                                    <div class="w-1/2">
                                                        <div class="relative w-full">
                                                            <label class="px-0 top-0 text-sm font-medium flex items-center">
                                                                <span>
                                                                    CVV
                                                                </span>
                                                            </label>
                                                            <div id="recurly-cvv"></div>
                                                            <span v-if="validation.cvv" class="text-red-100"> {{validation.cvv }} </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- Recurly.js will update this field automatically -->
                                            <input type="hidden" name="recurly-token" data-recurly="token">    
                                                <div class="w-full flex flex-col md:flex-row">
                                                    <div class="w-full md:w-1/2">
                                                        <div class="mb-5 relative w-full">
                                                            <label for="first_name" class="px-4 pt-3 absolute top-0 text-sm font-medium flex items-center">
                                                                <span> {{checkoutTranslate[language].user.cardName}} </span>
                                                            </label>
                                                            <div>
                                                                <input type="text"
                                                                    name="first_name"
                                                                    id="first_name" class="form-control"
                                                                    :placeholder="checkoutTranslate[language].user.exCardName" data-recurly="first_name" v-model="user.first_name">
                                                                <span v-if="validation.first_name" 
                                                                    class="text-red-100 text-sm font-medium">
                                                                        {{validation.first_name }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="w-full md:w-1/2 md:pl-4">
                                                        <div class="mb-5 relative w-full">
                                                            <label for="last_name" class="px-4 pt-3 absolute top-0 text-sm font-medium flex items-center">
                                                                <span>{{checkoutTranslate[language].user.cardLastname}}</span>
                                                            </label>
                                                            <div>
                                                                <input type="text"
                                                                    name="last_name"
                                                                    id="last_name"
                                                                    class="form-control"
                                                                   :placeholder="checkoutTranslate[language].user.exCardLName" 
                                                                    data-recurly="last_name"
                                                                    v-model="user.last_name">
                                                                <span v-if="validation.last_name"
                                                                    class="text-red-100 text-sm font-medium">
                                                                    {{validation.last_name }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex flex-row w-full">
                                                    <div class="mb-5 relative w-full">
                                                        <label for="dirección" class="px-4 pt-3 absolute top-0 text-sm font-medium flex items-center">
                                                            <span>
                                                                {{checkoutTranslate[language].user.direction}}
                                                            </span>
                                                        </label>
                                                        <div>
                                                            <input type="text" name="dirección" id="dirección" maxlength="50" class="form-control" :placeholder="checkoutTranslate[language].user.exDirection" data-recurly="address1">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex flex-col md:flex-row">
                                                    <div class="flex flex-col w-full md:w-1/3">
                                                        <div class="mb-5 relative w-full">
                                                            <label for="pais" class="px-4 pt-3 absolute top-0 text-sm font-medium flex items-center">
                                                                {{checkoutTranslate[language].user.country}}
                                                            </label>
                                                            <div>
                                                                <country-select v-model="user.country" :country="country" topCountry="MX"  data-recurly="country" class="font-semibold text-left focus:ring-green-400 focus:border-green-400 block w-full text-18 border-gray-300  pt-7 pb-2 px-3 rounded-xl shadow-sm border text-green-500 outline-none bg-white" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="w-full md:w-1/3 md:pl-4">
                                                        <div class="mb-5 relative w-full flex flex-row justify-center items-center space-x-4">
                                                            <div class="w-full relative">
                                                                <label for="ciudad" class="px-4 pt-3 absolute top-0 text-sm font-medium flex items-center">
                                                                    <span>
                                                                        {{checkoutTranslate[language].user.city}}
                                                                    </span>
                                                                </label>
                                                                <div>
                                                                    <input type="text" name="ciudad" id="ciudad" class="form-control" :placeholder="checkoutTranslate[language].user.exCity" data-recurly="city"  v-model="user.city" >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="w-full md:w-1/3 md:pl-4">
                                                        <div class="mb-5 relative w-full sm:space-x-4">
                                                            <div cass="w-full relative p-0">
                                                                <label for="postal" class="px-4 pt-3 absolute top-0 text-sm font-medium flex items-center">
                                                                    <span>
                                                                        {{checkoutTranslate[language].user.postalCode}}
                                                                    </span>
                                                                </label>
                                                                <div>
                                                                    <input type="text" name="postal" id="postal" class="form-control" :placeholder="checkoutTranslate[language].user.exPostalCode"   data-recurly="postal_code" v-model="user.zip">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div class="flex sm:flex-col xs:flex-col md:flex-row">
                                        <div class="w-6/12 sm:w-full xs:w-full  ">
                                            <p class=" text-md text-green-500 font-semibold md:font-bold pt-5 border-t">{{checkoutTranslate[language].payment.changetitle}}</p>
                                            <p>{{checkoutTranslate[language].payment.changesubtitle}}</p>
                                        </div>

                                        <div class="w-6/12 sm:w-full xs:w-full flex justify-end content-center items-center sm:justify-between xs:justify-between xs:pt-5 md:justify-end">
                                            <a  @click.prevent="goToLink('DashboardPago')" class="py-3 px-5 border-b-4 font-bold  text-green-500 md:mr-10 hover:border-green-200 hover:text-green-200 cursor-pointer">{{checkoutTranslate[language].button.cancel}}</a>
                                            <button class="py-6 px-8 xs:px-5 sm:px-5 border-b-5 font-bold  bg-blue-100 hover:bg-blue-200 text-white rounded-xl " @click="onChange">{{checkoutTranslate[language].button.change}}</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="my-5">
                        <div class="text-center p-10">
                            <div>{{dashboardTranslate[language].information.text }} </div>
                            <div><a :href="`mailto:${dashboardTranslate[language].information.email}`" class="text-green-400 font-semibold">{{dashboardTranslate[language].information.email }} </a></div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    <FooterCheckout />
    </div>
</template>

<script>
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

    import HeaderDashboard from "@/components/header/Header.vue"
    import FooterCheckout from "@/components/Footer.vue"
    import DashboardSidebarMenu from "@/components/dashboard/SidebarMenu.vue"
    import VivaLoader from "@/components/loader/Loader.vue"
    import DashboardUserCardInformation from '@/components/dashboard/UserCardInformation.vue'
    import Notification from "@/components/notifications/Notification.vue"
    import ModalValidation from "@/components/modals/ModalValidation.vue"
    import { notificationTranslate } from '@/translations/Notifications.js'
    import { checkoutTranslate } from '@/translations/Checkout.js'
    import { dashboardTranslate } from '@/translations/Dashboard.js'

    import { computed, ref } from "@vue/reactivity"
    import { useStore } from "vuex"
    import { onMounted } from "@vue/runtime-core"
    import { faEdit, faDownload, faArrowLeft, faArrowRight, faExclamationCircle} from '@fortawesome/free-solid-svg-icons'
    import { dataLayerCancelAddPaymentMehthod,dataLayerSavePaymentMethod,dataLayerAddPaymentMethod, dataLayerVerifyPaymentMethod} from '@/pixels/datalayer.js'

    import { recurlyKey } from '@/config/'
    import { env } from '@/api/environment.js'
import { useRouter } from "vue-router"

    export default ({
        name: 'Perfil',
        components: {
            HeaderDashboard,
            FooterCheckout,
            DashboardSidebarMenu,
            VivaLoader,
            Notification,
            DashboardUserCardInformation,
            ModalValidation,
            FontAwesomeIcon
        },
        setup(){
            /* eslint-disable*/
            recurly.configure(recurlyKey[env]);
            const elements =  recurly.Elements();
            const router = useRouter()
            const showModalValidation = ref( false )
            const onCloseValidation = () =>{
                    showModalValidation.value = false
                    validation.value = {}
            }

            const language = computed( ()=> {
                return  localStorage.getItem('viva-translate') ? localStorage.getItem('viva-translate') : 'es';
            })

            const setCardElements = ( subscription) => {
            
                const cardNumberElement = elements.CardNumberElement({
                     inputType: 'mobileSelect',
                style: {
                    fontSize: '20px',
                    padding: '10px 0',
                    fontFamily: 'Poppins, Lato, Helvetica, Arial, sans-serif',
                    fontWeight: '600',
                    fontColor: 'rgba(0, 38, 18, 1)',
                    placeholder: {
                        color: '#ACACAC !important',
                        content: 'XXXX XXXX XXXX '+subscription.billing.cardDetails.lastFourDigits,
                    },
                    invalid: {
                        fontColor: 'red'
                    }
                }
                });
                const cardMonthElement = elements.CardMonthElement({
                    inputType: 'mobileSelect',
                    style: {
                        fontSize: '20px',
                        padding: '10px 0',
                        fontFamily: 'Poppins, Lato, Helvetica, Arial, sans-serif',
                        fontWeight: '600',
                        fontColor: '#002612',
                        placeholder: {
                            color: '#8f8f8f !important',
                            content: subscription.billing.cardDetails.expirationMonth,
                        },
                        invalid: {
                            fontColor: 'red'
                        }
                    }
                });
                const cardYearElement = elements.CardYearElement({
                    inputType: 'mobileSelect',
                    style: {
                        width: '55px',
                        fontSize: '20px',
                        padding: '10px 0',
                        fontFamily: 'Poppins, Lato, Helvetica, Arial, sans-serif',
                        fontWeight: '600',
                        fontColor: '#002612',
                        placeholder: {
                            color: '#8f8f8f !important',
                            content: String(subscription.billing.cardDetails.expirationYear).slice(-2),
                        },
                        invalid: {
                            fontColor: 'red'
                        }
                    }
                });
                const cardCvvElement = elements.CardCvvElement({
                    inputType: 'mobileSelect',
                    style: {
                        fontSize: '20px',
                        padding: '10px 0',
                        fontFamily: 'Poppins, Lato, Helvetica, Arial, sans-serif',
                        fontWeight: '600',
                        fontColor: '#002612',
                        placeholder: {
                            color: '#8f8f8f !important',
                            content: 'XXX',
                        },
                        invalid: {
                            fontColor: 'red'
                        }
                    }
                });

                cardNumberElement.attach('#recurly-number');
                cardMonthElement.attach('#recurly-month');
                cardYearElement.attach('#recurly-year');
                cardCvvElement.attach('#recurly-cvv');

            }
            
           
            const store = useStore()
            const account = computed( () =>{
                return store.state.Accounts.data
            })
            const error = computed(() => {
                return store.state.Accounts.error.billing
            })

            const success = computed(() => {
                return store.state.Accounts.success.billing
            })
            const isSuccess = computed(() => {
                return store.state.Accounts.isSuccess.billing
            })
             const isError = computed(() => {
                return store.state.Accounts.isError.billing
            })



            const subscription = computed( () =>{
                return store.state.Checkout.data.userSubscription.data
            })
            const validation  = ref({
                month : null,
                number : null,
                year: null,
                first_name : null,
                last_name : null
            })
            const user = ref({
                first_name : null,
                last_name : null,
                country : null,
            })

            const checkSubscription = () =>{
                if( !subscription.value ){
                    router.push({name: 'Home'})
                }
            }
            const recurlyTokenHandler = async ( err, token  ) =>{
                if(err){ 
                    validation.value = []
                    if( err.details.length != 0 ){
                        const details = err.details 
                        details.forEach( ( { field, messages }) =>{
                            validation.value[field] = messages.join(' ')
                        } )
                    }
                    showModalValidation.value = true
                
                } else {
                    
                    dataLayerSavePaymentMethod( { city: user.value.city, country: user.value.country, zipcode: user.value.zip } )
                    dataLayerVerifyPaymentMethod()
                    await store.dispatch( 'updateBiling' , { token : token })

                    if( isSuccess.value ){
                        dataLayerAddPaymentMethod('success')
                    }
                     if( isError.value ){
                        dataLayerAddPaymentMethod('failed')
                    }
                }
            }

            const goToLink = ( routerName ) => {
                dataLayerCancelAddPaymentMehthod()
                router.push({name: routerName})
            }

            const onChange = () =>{
                
             
                recurly.token( elements , document.getElementById('form'),  recurlyTokenHandler )
            }

            const setUserData = () =>{
                user.value = {
                    first_name : subscription.value.billing.cardDetails.firstName ,
                    last_name : subscription.value.billing.cardDetails.lastName ,
                    country : subscription.value.customer.preferredLocale ?  subscription.value.customer.preferredLocale.split('-')[1] : null
                }
            }

              const formatExpirationDate = ( date ) =>{
                const expire = new Date(date)
                const options = { year: 'numeric', month: 'long', day: 'numeric' };

                const lang = language.value  == 'es' ? 'es-ES' : 'en-US'
                return expire.toLocaleDateString(lang, options)
            }

            onMounted( async () => {
               
                if( Object.keys(store.state.Accounts.data).length == 0 ){
                    await store.dispatch('checkAccount')
                }

                if( !subscription.value){
                    await store.dispatch('getSubscription', { plan: 'vfn'} )
                    checkSubscription()
                    setCardElements( subscription.value )
                    setUserData()
                } else {
                    await store.dispatch('getSubscription', { plan: 'vfn'} )
                    setCardElements( subscription.value )
                    setUserData()
                }
               
            })
            
            return { account,error, success, isSuccess, language, faEdit, faDownload, notificationTranslate, dashboardTranslate, faArrowLeft, faArrowRight, subscription, validation,user, checkoutTranslate,  onChange, onCloseValidation, showModalValidation, goToLink, formatExpirationDate, faExclamationCircle} 
        },
    
    })
</script>

<style scoped>
.box {
    @apply bg-white border border-gray-200 shadow rounded-lg text-left rounded-lg shadow overflow-hidden;
}
h5 {
    @apply md:text-sm text-green-400;
    font-size: 0.75rem;
}
input.form-control, select.form-control{
    @apply font-semibold text-left focus:ring-green-400 focus:border-green-400 block w-full text-18 border-gray-300 rounded-md pt-7 pb-2 px-4 rounded-xl shadow-sm border text-green-500 outline-none;
}
label > span {
    @apply text-green-500 sm:text-xs;
}
.form-check-radio {
    @apply w-5 h-5 border-2 rounded-full bg-blue-100;
}
.form-radio-wrapper {
    @apply flex content-center items-center pt-5 pb-0 md:py-5 w-full md:w-auto;
}
.disabled {
    @apply opacity-50 cursor-not-allowed
}

.fade-enter-from {
    opacity: 0;
    height: 0;
}
.fade-enter-to {
    opacity: 1;
    height: auto;
}
.fade-enter-active {
   transition: all 300ms ease-out;
}
.fade-leave-from {
    opacity: 1;
    height: auto;
}
.fade-leave-to {
    opacity: 0;
    height: 0;
}
.fade-leave-active {
   transition: all 300ms ease-out;
}
</style>